import { Page } from '@modules/pages/page';

export const getServerSideProps = Page.getServerSideProps;
export default Page.SecuredComponent;
